import React from 'react';
import BaseLayout from './base.js';
import TableLayout from './table.js';

/*---------------------------------------------*/

export default class ListLayout extends BaseLayout {
	render() {
		let rows = this.context.get('layout.rows');
		return <TableLayout items={this.props.items} rows={rows} columns={1} template={this.props.template} />
	}
}

/*---------------------------------------------*/
